$(document).ready(function () {
    $('.date').on('keypress', function (e) {
        var len = $(this).val().length;
        var value = $(this).val();
        if(len === 1 && e.keyCode === 46) {
            $(this).val(0+this.value);
        }
        else if(len === 4 && e.keyCode === 46) {
            var pos = $(this).val().indexOf('.', 0);
            $(this).val(value.substr(0, pos)+"."+0+value.substr(3, pos));
        }
        //only numbers
        else if(e.keyCode < 47 || e.keyCode > 57) {
            e.preventDefault();
        }

        //add a dot after the first two digits
        if(len === 2) {
            this.value += '.';
        }

        //add a dot after the month input
        if(len === 5) {
            this.value += '.';
        }
    });
});
